import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  makeStyles,
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

function useSeries() {
  const [series, setSeries] = useState([]);

  useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/series')
      .then((response) => response.json())
      .then((data) => {
        let s = data?.data?.map((serie) => {
          return {
            value: serie?._id,
            label: serie?.name,
          };
        });

        setSeries(s);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return { series };
}

function useGrades() {
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/grades')
      .then((response) => response.json())
      .then((data) => {
        let g = data?.data?.map((grade) => {
          return {
            value: grade?._id,
            label: grade?.name,
          };
        });

        setGrades(g);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return { grades };
}

const useStyles = makeStyles((theme) => ({
  filterChip: {
    width: '100%',
    maxWidth: '375px',
    backgroundColor: '#fff',
    padding: '24px 24px 36px',
    borderRadius: '4px',
    boxShadow:
      '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
  filterChipClose: {
    position: 'absolute',
    top: '4px',
    right: '4px',
  },
  filterChipHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'max-content',
    marginBottom: '16px',
  },
  filterChipTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    textTransform: 'uppercase',
  },
  filterChipResetLink: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    cursor: 'pointer',
  },
  filterChipBody: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    placeItems: 'center',
    gridGap: '16px',
    width: '100%',
  },
  filterChipFormControl: {
    width: '100%',
  },
  filterChipFormControlLabel: {
    left: '16px',
  },
  filterChipFormButton: {
    width: 'max-content',
    margin: '16px 0 0 auto',
  },
}));

export const FilterChip = ({
  setOpenFilter,
  filters,
  setFilters,
  defaultFilters,
}) => {
  const classes = useStyles();

  const [internalFilters, setInternalFilters] = useState(filters);

  const handleSetFilters = () => {
    setFilters(internalFilters);
    setOpenFilter(false);
  };

  const { series } = useSeries();
  const { grades } = useGrades();
  const [periods] = useState([1, 2, 3, 4]);
  const [questionTypes] = useState([
    ['evaluation', 'Evaluación'],
    ['workshop', 'Taller'],
  ]);
  const [activityTypes] = useState([
    'Prueba diagnóstica',
    'Evaluación de periodo',
    'Taller evaluativo 1',
    'Taller evaluativo 2',
    'Taller evaluativo 3',
    'Taller evaluativo 4',
    'Taller evaluativo 5',
    'Taller de práctica 1',
    'Taller de práctica 2',
    'Taller de práctica 3',
    'Taller de práctica 4',
    'Taller de práctica 5',
  ]);

  return (
    <article className={classes.filterChip}>
      <IconButton
        onClick={() => setOpenFilter(false)}
        className={classes.filterChipClose}
      >
        <CloseIcon />
      </IconButton>
      <article className={classes.filterChipHeader}>
        <p className={classes.filterChipTitle}>Filtros</p>
        <Button
          className={classes.filterChipResetLink}
          onClick={() => {
            setOpenFilter(false);
            setFilters(defaultFilters);
          }}
        >
          Limpiar filtros
        </Button>
      </article>
      <article
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className={classes.filterChipBody}
      >
        <FormControl className={classes.filterChipFormControl}>
          <InputLabel
            className={classes.filterChipFormControlLabel}
            id="label-period"
          >
            Serie
          </InputLabel>
          <Select
            labelId="label-period"
            id="select-period"
            value={internalFilters?.serie || ''}
            onChange={(e) =>
              setInternalFilters((prevState) => ({
                ...prevState,
                serie: e.target.value,
              }))
            }
            variant="outlined"
            label="Periodo"
          >
            <MenuItem value="">Todos</MenuItem>
            {series?.map((serie, index) => (
              <MenuItem key={index} value={serie.value}>
                {serie.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.filterChipFormControl}>
          <InputLabel
            className={classes.filterChipFormControlLabel}
            id="label-period"
          >
            Grado
          </InputLabel>
          <Select
            labelId="label-period"
            id="select-period"
            value={internalFilters?.grade || ''}
            onChange={(e) =>
              setInternalFilters((prevState) => ({
                ...prevState,
                grade: e.target.value,
              }))
            }
            variant="outlined"
            label="Periodo"
          >
            <MenuItem value="">Todos</MenuItem>
            {grades?.map((grade, index) => (
              <MenuItem key={index} value={grade.value}>
                {grade.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.filterChipFormControl}>
          <InputLabel
            className={classes.filterChipFormControlLabel}
            id="label-period"
          >
            Periodo
          </InputLabel>
          <Select
            labelId="label-period"
            id="select-period"
            value={internalFilters?.period || ''}
            onChange={(e) =>
              setInternalFilters((prevState) => ({
                ...prevState,
                period: e.target.value,
              }))
            }
            variant="outlined"
            label="Periodo"
          >
            <MenuItem value="">Todos</MenuItem>
            {periods?.map((period, index) => (
              <MenuItem key={index} value={period}>
                {period}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.filterChipFormControl}>
          <InputLabel
            className={classes.filterChipFormControlLabel}
            id="label-type"
          >
            Tipo
          </InputLabel>
          <Select
            labelId="label-type"
            id="select-type"
            value={internalFilters?.questionType || ''}
            onChange={(e) =>
              setInternalFilters((prevState) => ({
                ...prevState,
                questionType: e.target.value,
              }))
            }
            variant="outlined"
            label="Tipo"
          >
            <MenuItem value="">Todos</MenuItem>
            {questionTypes?.map((questionType, index) => (
              <MenuItem key={index} value={questionType[0]}>
                {questionType[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.filterChipFormControl}>
          <InputLabel
            className={classes.filterChipFormControlLabel}
            id="label-activity"
          >
            Actividad
          </InputLabel>
          <Select
            labelId="label-activity"
            id="select-activity"
            value={internalFilters?.activityType || ''}
            onChange={(e) =>
              setInternalFilters((prevState) => ({
                ...prevState,
                activityType: e.target.value,
              }))
            }
            variant="outlined"
            label="Actividad"
          >
            <MenuItem value="">Todos</MenuItem>
            {activityTypes?.map((activityType, index) => (
              <MenuItem key={index} value={activityType}>
                {activityType}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          className={classes.filterChipFormControl}
          label="Pregunta"
          variant="outlined"
          name="question"
          onChange={({ target: { value } }) =>
            setInternalFilters((prevState) => ({
              ...prevState,
              question: value,
            }))
          }
          value={internalFilters.question}
        />
      </article>
      <article className={classes.filterChipFormButton}>
        <Button onClick={handleSetFilters} variant="contained" color="primary">
          Filtrar
        </Button>
      </article>
    </article>
  );
};
